import React from 'react';
import { PageTitle } from '../index';

const TableTitle = ({ title = 'Table' }) => (
  <PageTitle>
    {title}
  </PageTitle>
);

export default TableTitle;
